import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useForm } from "react-hook-form"
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { ApiError } from "@/api/api"
import { toast } from "sonner"

interface CreatePaymentModalProps {
  onClose: () => void;
  onLinkTransaction: (txid: string) => void;
  description: string;
}

interface CreatePaymentForm {
  txid: string;
}

export function CreatePaymentModal({
  onClose,
  onLinkTransaction,
  description,
}: CreatePaymentModalProps) {
  const form = useForm<CreatePaymentForm>({
    defaultValues: {
      txid: "",
    },
  })

  const onSubmit = async ({ txid }: CreatePaymentForm) => {
    try {
      await onLinkTransaction(txid)
      toast.success("Transaction linked")
      onClose()
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) {
        form.setError(
          "txid",
          { message: "Transaction not found" },
          { shouldFocus: true },
        )
      } else throw err
    }
  }

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Link Transaction</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
          <DialogClose />
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-4 py-4">
              <FormField
                name="txid"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel required>Transaction ID</FormLabel>
                    <Input {...field} />
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
            <DialogFooter className="mt-0">
              <Button type="submit" data-testid="link-transaction">
                Link Transaction
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
